import { useCallback } from "react";
import { CountDown } from "./countdown";
import { useFreeChest } from "./data";

export function CountdownFreeChest() {
  const { data, mutate, isLoading } = useFreeChest();

  // trigger action when time count down is zero
  const toggle = useCallback(() => {
    mutate();
  }, [mutate]);

  if (isLoading || !data?.isOpenFreeChest) {
    return null;
  }

  return <CountDown timestamp={data?.timestamp} toggle={toggle} />;
}
